/**
 * Desk's Repository Intelligence endpoints (`apps/api/src/modules/repository-intelligence`).
 *
 * The browser and the mobile app only ever talk to Desk: these are Desk's answers, built by
 * allow-list mappers from what Desk Repository Intelligence (DRI) said. Nothing here names DRI's
 * address, token, keys or its own names and paths for the repository.
 */
/** The kinds of symbol Repository Intelligence's index records (`GET …/intelligence/symbols?kind=`). */
export const REPOSITORY_INTELLIGENCE_SYMBOL_KINDS = [
    'namespace',
    'module',
    'class',
    'interface',
    'trait',
    'enum',
    'type',
    'function',
    'method',
    'variable',
];
//# sourceMappingURL=repository-intelligence.js.map